export default {
  MAINTENANCE: 'maintenance',
  REPLACEMENT: 'replacement',
};

